export class ReWeighmentInfo{
    grnId?: number;
    grnItemId?: number;

    constructor(

        grnId?:number,
        grnItemId?:number,
        ){
      this.grnId = grnId;
      this.grnItemId = grnItemId;

    }
}